export default __webpack_public_path__ + "static/media/img_503.b0aadba9.svg";